import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserHomeBaseForm } from "Bands/components";
import { createUserHomeBase, dispatchGetUserHomeBases } from "Bands/state";
import { IUserHomeBasePatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Train } from "shared/assets/icons";

const { userHomeBase: baseCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserHomeBaseModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: baseCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserHomeBasePatchData) => {
    dispatch(createUserHomeBase(data));
  };

  const handleSuccess = () => {
    dispatchGetUserHomeBases(dispatch);
  };

  return (
    <UserEntityModal
      title={baseCopy.create.title}
      icon={Train}
      action={USER_ACTIONS.createUserHomeBase}
      buttons={buttons}
      successMessage={baseCopy.messages.created}
      Component={UserHomeBaseForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
